/* ==========================================================================
   Bedrock — bdr-peek
   Replie une liste en laissant dépasser une amorce : le premier item entier,
   CTA compris, plus une fraction du suivant réglée par data-bdr-peek-ratio.
   La hauteur est mesurée sur le DOM réel plutôt que devinée, et remesurée
   quand la liste change de taille.
   ========================================================================== */

(function () {
  'use strict';

  if (customElements.get('bdr-peek')) return;

  class BdrPeek extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-bdr-peek-viewport]');
      this.toggle = this.querySelector('[data-bdr-peek-toggle]');
      this.label = this.querySelector('[data-bdr-peek-label]');
      if (!this.viewport || !this.toggle) return;

      this.items = Array.from(this.viewport.querySelectorAll('[data-bdr-peek-item]'));

      // Moins de deux items : rien à révéler, on laisse la liste ouverte.
      if (this.items.length < 2) {
        this.toggle.remove();
        return;
      }

      this.ratio = Math.min(1, Math.max(0, Number(this.dataset.bdrPeekRatio) || 0.5));
      this.expanded = false;

      this.handleToggle = this.handleToggle.bind(this);
      this.measure = this.measure.bind(this);
      this.toggle.addEventListener('click', this.handleToggle);

      // On observe la liste, pas le viewport : le viewport est celui dont on
      // pilote la hauteur, l'observer y bouclerait sur lui-même.
      this.list = this.items[0].parentElement;
      if ('ResizeObserver' in window && this.list) {
        this.observer = new ResizeObserver(this.measure);
        this.observer.observe(this.list);
      }

      this.measure();
      this.render();
      this.setAttribute('data-bdr-peek-ready', '');
    }

    disconnectedCallback() {
      if (this.toggle) this.toggle.removeEventListener('click', this.handleToggle);
      if (this.observer) this.observer.disconnect();
    }

    measure() {
      const top = this.viewport.getBoundingClientRect().top;
      const second = this.items[1].getBoundingClientRect();
      if (!second.height) return;
      const height = second.top - top + second.height * this.ratio;
      this.style.setProperty('--bdr-peek-h', Math.round(height) + 'px');
    }

    handleToggle() {
      this.expanded = !this.expanded;
      this.render();
    }

    render() {
      this.toggleAttribute('open', this.expanded);
      this.toggle.setAttribute('aria-expanded', String(this.expanded));

      if (this.label) {
        const next = this.expanded ? this.toggle.dataset.bdrLabelLess : this.toggle.dataset.bdrLabelMore;
        if (next) this.label.textContent = next;
      }

      // Ce qui est masqué ne doit pas happer le focus clavier.
      this.items.slice(1).forEach((item) => {
        item.inert = !this.expanded;
      });
    }
  }

  customElements.define('bdr-peek', BdrPeek);
})();
